import React, { useMemo } from 'react';
import Wrapper from 'components/HOC/wrapper';
import useImageSizes from 'helpers/hooks/useImageSizes';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, tablet } from 'helpers/utils/screensizes';
import Slider from '../../../atoms/slider';
import Tile, { TileProps } from '../../../molecules/tile';

export interface Props {
  tiles: TileProps[];
}

const TilesGroup: React.FC<Props> = ({ tiles }) => {
  const imageSizes = useImageSizes({ md: 1, lg: 0.5, defaultSize: 0.5 });
  const [isDesktopSize] = useMediaQuery(desktop);

  const tileElements = useMemo(
    () =>
      tiles.map((tile, index) => {
        const image = tile.image ? { ...tile.image, fill: true, sizes: imageSizes, alt: tile.title ?? '' } : undefined;

        return <Tile key={index} {...tile} image={image} className="h-320 lg:h-[475px]" />;
      }),
    [tiles, imageSizes],
  );

  return (
    <Wrapper background="white" clearDefaultStyles className="w-full px-16 pb-24 md:px-48">
      <div className="mx-auto max-w-screen-2xl">
        <h2 className="mb-16 text-28 font-medium leading-[32px] text-primary md:text-64 md:leading-[68px]">
          {'Shop by device'}
        </h2>
        {isDesktopSize ? (
          <div className="grid grid-cols-2 gap-8 lg:gap-16">{tileElements}</div>
        ) : (
          <Slider
            containerClassName=""
            slidesPerView={1.2}
            spaceBetween={8}
            dots={false}
            breakpoints={{
              [tablet]: {
                slidesPerView: 1.7,
                spaceBetween: 16,
              },
            }}
          >
            {tileElements}
          </Slider>
        )}
      </div>
    </Wrapper>
  );
};

export default TilesGroup;
